import tw from "twin.macro"
import React from "react"
import { SanityFeatSnippetImg } from "./FeaturedSnippetModule.d"
import { Image } from "../../atoms/Image"

const FeaturedSnippetImage: React.FC<SanityFeatSnippetImg> = ({
  _key,
  image,
  fromHybridSegment = false,
}) => {
  return (
    <div css={[tw`h-auto`]} key={_key}>
      <Image
        imageData={image.image}
        css={[
          tw`w-full object-cover`,
          fromHybridSegment && tw`md:(max-w-[491px] mx-auto w-full)`,
        ]}
      />
    </div>
  )
}
export default FeaturedSnippetImage
